export default(Vue) => {
    // 防抖指令
    Vue.directive("debounce", {
        inserted: function(el, binding) {
            let wait = false;
            el.addEventListener("click", () => {
                if(!wait) {
                    wait = true
                    binding.value();
                    setTimeout(() => {
                        wait = false
                    }, 800)      
                }
            });
        }
    })
}